import { Component, Input, OnInit } from '@angular/core';
import { SearchResultCustomerAddress } from 'src/app/models/search/search-result-customer-address';

@Component({
  selector: 'app-customer-address-card',
  templateUrl: './customer-address-card.component.html',
  styleUrls: ['./customer-address-card.component.scss'],
})
export class CustomerAddressCardComponent implements OnInit {

  @Input() address: SearchResultCustomerAddress;
  @Input('showCustomer') showCustomer: boolean = true;
  
  constructor() { }

  ngOnInit() {}

}
